<template>
  <div class="track">
    <van-form ref="form" @submit="submitForm">
      <van-field
        label="客户名称"
        readonly
        right-icon="arrow"
        :value="customerName"
        :rules="[{ required: true, message: '请选择客户', trigger: 'onChange' }]"
        @click="visible = true"
      />
      <van-field
        v-model="formData.content"
        type="textarea"
        rows="4"
        :rules="[{ required: true, message: '', trigger: 'onChange' }]"
        placeholder="请输入沟通内容"
      />
      <van-field>
        <template #input>
          <UploadImage @uploadImage="formData.image = $event" />
        </template>
      </van-field>
      <div class="form-footer">
        <van-button type="primary" size="small" native-type="submit">确定</van-button>
      </div>
    </van-form>
    <CustomerPopup :visible.sync="visible" @select-item="handleSelectCustomer" />
  </div>
</template>

<script>
import { addTrackRecord } from '@/api/track'
import UploadImage from '@/components/img/upload'
import CustomerPopup from '../customer/components/list'
export default {
  name: 'CreateTrack',
  components: { UploadImage, CustomerPopup },
  data() {
    return {
      visible: false,
      customerName: this.$route.query.name || '',
      formData: {
        customerId: this.$route.query.id,
        content: undefined,
        image: undefined
      }
    }
  },
  methods: {
    handleSelectCustomer(item) {
      this.formData.customerId = item.id
      this.customerName = item.customerName
    },
    submitForm() {
      const { customerId, image } = this.formData
      addTrackRecord({ ...this.formData, customerId: Number(customerId), image: image || undefined }).then((res) => {
        if (res.errcode === 0) {
          this.$router.go(-1); // 返回跳转创建客户页面
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .track {
    .form-footer { margin-top: 20px; text-align: center;
      .van-button { padding: 0 30px; }
    }
  }
</style>